package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ICountableQuiz
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.QuizText
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.quizSelectionCorrectBg
import com.shadowings.gero.presentation.ui.quizSelectionWrongBg
import com.shadowings.gero.presentation.util.DevicePreviews
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.circle
import gero.composeapp.generated.resources.circle_ko
import gero.composeapp.generated.resources.circle_ok
import org.jetbrains.compose.resources.painterResource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun QuizHeaderPreview() {
    AppTheme {
        Surface {
            QuizHeader(
                quizList = (0..10).map {
                    SingleSelectionContent(
                        id = it.toString(),
                        text = QuizText.Plain("Come si pronuncia questo geroglifico?"),
                        detail = "G7",
                        options = listOf()
                    )
                },
                currentPage = 3,
                quizResults =
                    mapOf("0" to true, "1" to false, "2" to false)
            )
        }
    }
}

@Composable
fun QuizHeader(
    quizList: List<IQuizContent>,
    currentPage: Int,
    quizResults: Map<String, Boolean>
) {
    Column(
        Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 6.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            quizList
                .filterIsInstance<ICountableQuiz>()
                .forEach { quiz ->
                    val value = quizResults[quiz.id]
                    Box {
                        Box(
                            Modifier.align(
                                Alignment.Center
                            ).size(14.dp).background(
                                when (value) {
                                    true -> quizSelectionCorrectBg
                                    false -> quizSelectionWrongBg
                                    else -> Color.Transparent
                                },
                                shape = CircleShape
                            )
                        )
                        Image(
                            modifier = Modifier.size(18.dp),
                            painter = painterResource(
                                when (value) {
                                    true -> Res.drawable.circle_ok
                                    false -> Res.drawable.circle_ko
                                    else -> Res.drawable.circle
                                }
                            ),
                            contentDescription = null,
                            colorFilter = if (value == null) {
                                ColorFilter.tint(MaterialTheme.colorScheme.outlineVariant)
                            } else {
                                null
                            },
                        )
                    }
                }
        }
    }
}
